module.exports = __webpack_public_path__ + "img/zeilwagenrijden--dark.ebe289ba.svg";